import { get, post, put, patch } from "../index";
import AdbooksRoutes from "./Adbooks.Routes";

const AdBooksServices = {
  getAllAdbooks: async (catId, search, page, limit, type) => {
    let params = `?page=${page}&limit=${limit}&type=${type}`;
    if (catId) params += `&category=${catId}`
    if (search) params += `&title=${search}`
    const result = await get(AdbooksRoutes.getAllAdbooks + params
    );
    return result;
  },
  createAdbook: async (obj) => {
    const result = await post(AdbooksRoutes.createAdbook, obj);
    return result;
  },

  updateAdbook: async (id, obj) => {
    const result = await put(AdbooksRoutes.updateAdbook + `/${id}`, obj);
    return result;
  },

  approveBlog: async (id, obj) => {
    const result = await patch(AdbooksRoutes.approveBlog + `/${id}`, obj);
    return result;
  },

  updateSequence: async (obj) => {
    const result = await patch(AdbooksRoutes.updateSequence, obj);
    return result;
  }
}

export default AdBooksServices;